import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorAssessmentModal } from '../ErrorAssessmentModal';
import { CompleteAssessmentModal } from '../CompleteAssessmentModal';
import {
  getAssessment,
  postAssessment,
  putAssessment,
} from '../../store/assessmentSingle/actions';
import { IAppState } from '../../store';
import { useHistory } from 'react-router';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';

interface IProps {
  assessmentsId: any;
  isHaveErrors?: (boolean) => void;
  dataP: any;
  changedFieldsId?: any;
  setChangedFieldsId?: React.Dispatch<React.SetStateAction<any>>;
  setUserHandleSaveData?: React.Dispatch<React.SetStateAction<boolean>>;
  userHandleSaveData: boolean;
}

const CompleteAssessment = ({
  changedFieldsId,
  userHandleSaveData,
  setUserHandleSaveData,
  setChangedFieldsId,
  assessmentsId,
  isHaveErrors,
  dataP,
}: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data } = useSelector((state: IAppState) => state.singleAssessment);
  const originalData = useSelector((state: IAppState) => state.singleAssessment.originalData);
  const assessment = useSelector(
    (state: IAppState) => state.singleAssessment.data,
  ).find(ass => ass.Pages.some(p => p.ID === dataP.ID));
  
  const { Pages = [], ID = 0, StatusFlag = 0 } = assessment || {};
  const { errors, values } = useFormikContext();
  const [buttonClicked, setButtonClicked] = useState(false);
  const [showAgreePopup, setShowAgreePopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const { t, i18n } = useTranslation();

  const handleSaveClick = async () => {
    const dataToPost = [];
    let objEmpty = [];
    
    if (Pages && Pages.length > 0) {
      Pages.forEach(p =>
        p.Fields.forEach(f => {
                      if (f.Template.FieldType.Name === 'Grid') {
              // Find original grid field by Template ID across all pages
              let originalGridField = null;
              if (originalData && originalData[0] && originalData[0].Pages) {
                originalData[0].Pages.forEach(originalPage => {
                  if (originalPage.Fields) {
                    const foundField = originalPage.Fields.find(originalField => 
                      originalField.Template.ID === f.Template.ID
                    );
                    if (foundField) {
                      originalGridField = foundField;
                    }
                  }
                });
              }
              
              // Preserve existing IDs and generate new ones only for new fields
              f.GridChildren = f.GridChildren.map((row, rowIndex) => 
                row.map((field, fieldIndex) => {
                  if (field.ID && typeof field.ID === 'number' && field.ID > 0) {
                    return { ...field };
                  }
                  
                  const originalFieldsMap = new Map();
                  if (originalGridField?.GridChildren) {
                    originalGridField.GridChildren.forEach((origRow, origRowIndex) => {
                      origRow.forEach(origField => {
                        const key = `${origField.Template.ID}_${origField.GridRow}`;
                        originalFieldsMap.set(key, origField);
                      });
                    });
                  }
                  
                  const key = `${field.Template.ID}_${field.GridRow}`;
                  const originalField = originalFieldsMap.get(key);
                  
                  if (originalField && originalField.ID) {
                    return { ...field, ID: originalField.ID };
                  }
                  
                  // If not found by position, try to find by Template ID only (for new rows)
                  const foundByTemplate = originalGridField?.GridChildren?.flat()?.find(origField => 
                    origField.Template.ID === field.Template.ID
                  );
                  
                  if (foundByTemplate && foundByTemplate.ID) {
                    return { ...field, ID: foundByTemplate.ID };
                  }
                  
                  // Only generate new ID for truly new fields that don't exist in original data
                  return { ...field, ID: Date.now() + Math.random() };
                })
              );
            
            f.GridChildren.forEach(fieldsArray => {
              fieldsArray.forEach(field => {
                if (values[f.Guid] && values[f.Guid][field.GridRow] && values[f.Guid][field.GridRow][field.Template.Name] !== undefined) {
                  field.Value = values[f.Guid][field.GridRow][
                    field.Template.Name
                  ] as string | null;
                }
              });
            });
            if (changedFieldsId.includes(f.Guid)) {
              const cleanGridField = {
                ID: f.ID,
                Guid: f.Guid,
                GridRow: f.GridRow,
                GridColumn: f.GridColumn,
                Value: f.Value,
                Template: {
                  ID: f.Template.ID,
                  Name: f.Template.Name,
                  DisplayName: f.Template.DisplayName,
                  Required: f.Template.Required,
                  Order: f.Template.Order,
                  HelpText: f.Template.HelpText,
                  GridChild: f.Template.GridChild,
                  FieldAlias: f.Template.FieldAlias,
                  FieldType_ID: f.Template.FieldType_ID,
                  FieldType: {
                    ID: f.Template.FieldType.ID,
                    Name: f.Template.FieldType.Name,
                    Discriminator: f.Template.FieldType.Discriminator
                  },
                  Parameters_ID: f.Template.Parameters_ID,
                  Parameters: f.Template.Parameters || {
                    ID: f.Template.Parameters_ID,
                    Expression: null,
                    ValuesListID: 0,
                    MultiLine: false,
                    Discriminator: null,
                    MeasureDetail_ID: 0,
                    ShowRowsAsColumns: false,
                    FieldTemplateToMirror_ID: 0
                  },
                  Validator_ID: f.Template.Validator_ID,
                  Validator: f.Template.Validator || {
                    ID: f.Template.Validator_ID,
                    MinimumDate: null,
                    MaximumDate: null,
                    MinRows: 0,
                    MaxRows: 0,
                    AllRowsVisible: false,
                    Minimum: 0,
                    Maximum: 0,
                    IntegerOnly: false,
                    MinimumLength: 0,
                    MaximumLength: 0,
                    Discriminator: null
                  },
                  OriginalSize: f.Template.OriginalSize,
                  OriginalWidth: f.Template.OriginalWidth,
                  OriginalHeight: f.Template.OriginalHeight,
                  MaintainAspectRatio: f.Template.MaintainAspectRatio,
                  InitiallyVisibleOnLoad: f.Template.InitiallyVisibleOnLoad,
                  VisibleExternally: f.Template.VisibleExternally,
                  Archived: f.Template.Archived,
                  ImageOnly: f.Template.ImageOnly,
                  HasImage: f.Template.HasImage
                },
                GridChildren: f.GridChildren.map(row => 
                  row.map(field => ({
                    ID: field.ID,
                    Guid: field.Guid,
                    GridRow: field.GridRow,
                    GridColumn: field.GridColumn,
                    Value: field.Value,
                    Template: {
                      ID: field.Template.ID,
                      Name: field.Template.Name,
                      DisplayName: field.Template.DisplayName,
                      Required: field.Template.Required,
                      Order: field.Template.Order,
                      HelpText: field.Template.HelpText,
                      GridChild: field.Template.GridChild,
                      FieldAlias: field.Template.FieldAlias,
                      FieldType_ID: field.Template.FieldType_ID,
                      FieldType: {
                        ID: field.Template.FieldType.ID,
                        Name: field.Template.FieldType.Name,
                        Discriminator: field.Template.FieldType.Discriminator
                      },
                      Parameters_ID: field.Template.Parameters_ID,
                      Parameters: field.Template.Parameters || {
                        ID: field.Template.Parameters_ID,
                        Expression: null,
                        ValuesListID: 0,
                        MultiLine: false,
                        Discriminator: null,
                        MeasureDetail_ID: 0,
                        ShowRowsAsColumns: false,
                        FieldTemplateToMirror_ID: 0
                      },
                      Validator_ID: field.Template.Validator_ID,
                      Validator: field.Template.Validator || {
                        ID: field.Template.Validator_ID,
                        MinimumDate: null,
                        MaximumDate: null,
                        MinRows: 0,
                        MaxRows: 0,
                        AllRowsVisible: false,
                        Minimum: 0,
                        Maximum: 0,
                        IntegerOnly: false,
                        MinimumLength: 0,
                        MaximumLength: 0,
                        Discriminator: null
                      },
                      OriginalSize: field.Template.OriginalSize,
                      OriginalWidth: field.Template.OriginalWidth,
                      OriginalHeight: field.Template.OriginalHeight,
                      MaintainAspectRatio: field.Template.MaintainAspectRatio,
                      InitiallyVisibleOnLoad: field.Template.InitiallyVisibleOnLoad,
                      VisibleExternally: field.Template.VisibleExternally,
                      Archived: field.Template.Archived,
                      ImageOnly: field.Template.ImageOnly,
                      HasImage: field.Template.HasImage
                    },
                    GridChildren: field.GridChildren || [],
                    Invalid: field.Invalid
                  }))
                ),
                Invalid: f.Invalid
              };
              
              dataToPost.push(cleanGridField);
            }
          } else {
            if (changedFieldsId.includes(f.Guid)) {
              dataToPost.push({
                ...f,
                Value: values[f.Guid] !== undefined ? values[f.Guid] as string : f.Value,
              });
            }
          }
        }),
      );
    }
    
    await dispatch(postAssessment(dataToPost, false));

    dispatch(putAssessment(assessmentsId));

    //dispatch(getAssessment(`${ID}`));
  };

  const pagesSet: Set<string> = new Set();
  Object.keys(errors).forEach(key => {
    const assessment = data.find(ass => ass.Pages.some(p => p.Fields.some(f => f.Guid === key)));
    if (assessment) {
      const page = assessment.Pages.find(p => p.Fields.some(f => f.Guid === key));
      if (page) {
        pagesSet.add(page.Template.Name);
      }
    }
  });
  let tabsToFix = Array.from(pagesSet).join(', ');

  const onClick = () => {
    setButtonClicked(true);
    isHaveErrors(true);
  };

  const onExitAgreePopup = () => {
    setShowAgreePopup(false);
    setButtonClicked(false);
  };

  const onExitErrorPopup = () => {
    setShowErrorPopup(false);
    setButtonClicked(false);
  };

  const completeAssessmentHandler = async () => {
    setButtonClicked(false);
    //await dispatch(putAssessment(assessmentsId));
    setUserHandleSaveData(true);
    handleSaveClick();
    dispatch(getApiAssessment());
    history.push(ROUTES.assessments);
  };

  useEffect(() => {
    if (buttonClicked && Object.keys(errors).length) {
      setShowErrorPopup(true);
    } else if (buttonClicked) {
      setShowAgreePopup(true);
    }
    if (Object.keys(errors).length) {
      setShowAgreePopup(false);
    }
  }, [
    buttonClicked,
    errors,
    showAgreePopup,
    setShowErrorPopup,
    setShowAgreePopup,
  ]);

  return (
    <>
      <button
        className="assessment-complete btn action-primary"
        onClick={onClick}
        // onClick={completeAssessmentHandler}
        disabled={StatusFlag === 2 || StatusFlag === 5}
      >
        {t('AP_as_compl')}
      </button>
      <CompleteAssessmentModal
        isOpen={showAgreePopup}
        onComplete={completeAssessmentHandler}
        onExit={onExitAgreePopup}
      />
      <ErrorAssessmentModal
        isOpen={showErrorPopup}
        onExit={onExitErrorPopup}
        text={`${t('AP_tabs')} ${tabsToFix}`}
      />
    </>
  );
};

export { CompleteAssessment };
